import {viewerDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'
import {FocusHandler} from '../../../../../commons/components/focus-handler'
import {ToastHandler} from '../../../../../commons/components/toast-handler'
import {Direction} from '../../../../../commons/constants/html'
import {isMobile} from '../../../../../commons/selectors/environment'
import {ROOT_COMPONENT_ID} from '../../config/constants'
import {useMembersPageSelector} from '../../hooks/runtime'
import {getRoute} from '../../selectors/navigation'
import {Router} from '../router'
import s from './app-container.scss'
import {AppContainerProps} from './interfaces'

export const AppContainer = ({isRTL}: AppContainerProps) => {
  const rootRef = useRef<HTMLDivElement>()

  const mobile = useMembersPageSelector(isMobile)
  const route = useMembersPageSelector(getRoute)

  useEffect(() => {
    rootRef.current.setAttribute('data-hydrated', 'true')
  }, [])

  return (
    <div ref={rootRef} dir={isRTL ? Direction.RTL : Direction.LTR} data-hook={DH.ROOT_NODE}>
      <FocusHandler />
      <ToastHandler />
      <div id={ROOT_COMPONENT_ID} className={classNames(s.root, {[s.mobile]: mobile})}>
        <Router route={route} mobile={mobile} />
      </div>
    </div>
  )
}
